import { logger } from "@src/utils/logger"
import { useEffect, useState } from "react"

// signed_out + restoring reflects wallet-SDK loading flags (see
// useWalletSnapshot's isLoading) that have no timeout of their own — if one
// of those SDKs hangs (e.g. a wallet connector promise never settles), this
// branch would otherwise keep the splash up forever. Fail open after this
// long, matching authMachine's RESTORE_TIMEOUT.
export const SIGNED_OUT_RESTORE_TIMEOUT_MS = 10_000

type LoginSplashState = {
  bootstrapState: string
  restoreStatus: "restoring" | "settled"
  interactionStatus: "idle" | "connecting" | "signing"
  restoreTimedOut: boolean
}

export function shouldShowLoginRestoreSplash({
  bootstrapState,
  restoreStatus,
  interactionStatus,
  restoreTimedOut,
}: LoginSplashState): boolean {
  return (
    interactionStatus === "idle" &&
    (bootstrapState === "initializing" ||
      (bootstrapState === "signed_out" &&
        restoreStatus === "restoring" &&
        !restoreTimedOut))
  )
}

export function useSignedOutRestoreTimeout(
  isRestoring: boolean,
  timeoutMs: number = SIGNED_OUT_RESTORE_TIMEOUT_MS
): boolean {
  const [timedOut, setTimedOut] = useState(false)

  useEffect(() => {
    if (!isRestoring) {
      setTimedOut(false)
      return
    }

    const timer = setTimeout(() => {
      logger.warn("[loginSplash] signed_out wallet restore timed out")
      setTimedOut(true)
    }, timeoutMs)

    return () => clearTimeout(timer)
  }, [isRestoring, timeoutMs])

  return timedOut
}
